import React, { useEffect, useRef, useState } from "react";
// eslint-disable-next-line import/no-unresolved
import pdfWs from 'images/pdf-ws.png';

import { isEmpty } from "lodash";
import fileUtils from '../../util/fileUtils';

// eslint-disable-next-line import/extensions
const pdfjs = require('pdfjs-dist/legacy/build/pdf');

pdfjs.GlobalWorkerOptions.workerSrc = URL.createObjectURL(
  new Blob([`importScripts('${require('pdfjs-dist/legacy/build/pdf.worker.mjs')}');`], {
    type: 'application/javascript',
  })
);

const PreviewFile = ({
  selectedFile,
  imageSize,
  attachedFile,
  direction = 'out'
}) => {
  const fileRef = useRef();

  const [fileToImage, setFileToImage] = useState(null);
  const [fileTextPages, setFileTextPages] = useState('');
  const [fileType, setFileType] = useState('');
  const [url, setUrl] = useState('');

  const bgDesContainer = direction == 'out' ? 'outgoing-background-deeper' : 'incoming-background-deeper';

  const renderPDFToCanvas = async (pdfUrl, pageNum, canvasElement) => {
    const loadingTask = pdfjs.getDocument(pdfUrl);
    const pdfDocument = await loadingTask.promise;

    const text = pdfDocument.numPages > 1 ? 'páginas' : 'página';
    setFileTextPages(`${pdfDocument.numPages} ${text}`);

    const page = await pdfDocument.getPage(pageNum);

    const viewport = page.getViewport({ scale: 1 });
    canvasElement.width = viewport.width;
    canvasElement.height = viewport.height;

    const canvasContext = canvasElement.getContext('2d');
    const renderContext = {
      canvasContext,
      viewport
    };

    await page.render(renderContext).promise;
  };

  const convertPdfFileToImage = async () => {
    let pdfUrl;

    if (selectedFile) {
      pdfUrl = URL.createObjectURL(selectedFile);
    } else if (attachedFile) {
      pdfUrl = attachedFile.url;
    }

    if (!pdfUrl) return;

    const pageNumber = 1;
    const canvasElement = document.createElement('canvas');

    await renderPDFToCanvas(pdfUrl, pageNumber, canvasElement);

    // Convert the canvas to an image
    const imgDataUrl = canvasElement.toDataURL('image/png');
    setFileToImage(imgDataUrl);
  };

  useEffect(() => {
    if (!selectedFile) return;

    setFileType(selectedFile.type);
    setUrl(URL.createObjectURL(selectedFile));
    if (fileType?.includes('video') || fileType?.includes('audio')) fileRef.current.load();
    if (selectedFile.type != 'application/pdf') return;

    convertPdfFileToImage();
  }, [selectedFile]);

  useEffect(() => {
    if (!attachedFile) return;

    if (!selectedFile) {
      setFileType(attachedFile.content_type);
      setUrl(attachedFile.url);
    }
    if (attachedFile.content_type != 'application/pdf') return;

    convertPdfFileToImage();
  }, [attachedFile]);

  const renderFileName = () => {
    if (selectedFile) return selectedFile.name;
    if (attachedFile) return attachedFile.filename;

    return '';
  };

  const getDimensions = () => {
    if (selectedFile?.type?.includes('image')) {
      return { width: selectedFile.width, height: selectedFile.height };
    }
    if (attachedFile?.content_type?.includes('image')) {
      return { width: attachedFile.width, height: attachedFile.height };
    }

    return {};
  };

  const renderFileSize = () => {
    if (selectedFile) return fileUtils.formatFileSize(selectedFile.size);
    if (attachedFile) return fileUtils.formatFileSize(attachedFile.size);

    return 0;
  };

  const renderPdfFile = () => (
    <div className="pdf-file-container">
      <div className="document-thumb">
        <div className="document-container">
          <div className="document-cover" style={{ backgroundImage: `url(${fileToImage})` }} />
        </div>
      </div>
      <div className={`document-des-container ${bgDesContainer}`}>
        <div className="document-des">
          <img src={pdfWs} title="pdf" className="pdf-icon" />
          <div className="file-attributes">
            <span className="file-name">{renderFileName()}</span>
            <div className="properties">
              <span>{fileTextPages}</span>
              <span className="dot">.</span>
              <span>PDF</span>
              <span className="dot">.</span>
              <span>{renderFileSize()}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderImage = () => {
    if (!imageSize || isEmpty(imageSize)) return;

    let containerStyle = {};

    if (imageSize.width > 330) {
      containerStyle = {
        width: '330px',
        height: imageSize.height > 235 ? `${82.5 + ((imageSize.height - 235) * 0.15)}px` : '82.5px'
      };
    } else {
      containerStyle = {
        width: '240px',
        height: '313.5px'
      };
    }

    if (imageSize.width > 330) {
      return (
        <div className="container-4" style={containerStyle}>
          <div className="img-cover" style={{ background: `url(${url})` }}>
          </div>
        </div>
      );
    }

    return (
      <div className="container-4">
        <div className="container-3" style={containerStyle}>
          <img src={url} className={`border-10 ${imageSize?.width < 240 ? 'w-100' : ''}`} />
        </div>
      </div>
    );
  };

  const renderAudio = () => (
    <div className="container-4">
      <div className="container-3" style={{ width: '330px' }}>
        <audio id="preview-template-image" ref={fileRef} controls className="border-10 d-block w-100 my-5 px-15">
          <source src={url} className="w-100 h-100" />
        </audio>
      </div>
    </div>
  );

  const renderVideo = () => (
    <div className="container-4">
      <div className="container-3" style={{ width: '330px' }}>
        <video id="preview-template-image" ref={fileRef} controls className="border-10 d-block w-100">
          <source src={url} className="w-100 h-100" />
        </video>
      </div>
    </div>
  );

  const renderPreviewFile = () => {
    if (!selectedFile && !attachedFile) return;

    if (fileType === 'application/pdf') {
      if (!fileToImage) return;

      return renderPdfFile();
    }

    if (['video/mp4', 'video/3gpp'].includes(fileType)) {
      return renderVideo();
    }

    if (['audio/mpeg', 'audio/mp3'].includes(fileType)) {
      return renderAudio();
    }

    if (!imageSize) return false;

    return renderImage();
  };

  return (
    <>
      {(selectedFile || attachedFile) && renderPreviewFile()}
      {/* {(attachedFile && !selectedFile) && renderAttachedFile()} */}
    </>
  );
};

export default PreviewFile;
